import React from 'react';
import { Link } from 'react-router-dom';
import gg_plus_logo from '../../images/logos/gg_plus/gg_plus_103.png';
import {
  logGgPlusFeatureGateViewed,
  logGgPlusUpgradeClicked,
} from '../../utils/ggPlusAnalytics';
import './Gg_plus_shared.css';

/**
 * Compact GG+ promo card — home dashboard, etc.
 * Generic copy (no child name).
 */
function Gg_plus_card({
  headline = 'Grow more support',
  body = 'Unlock monthly gifting, gift matching, and new tools that allow family and friends to give more consistently over time.',
  ctaText = 'Upgrade to GG+',
  to,
  onClick,
  analyticsSource = 'home',
  className = '',
}) {
  React.useEffect(() => {
    logGgPlusFeatureGateViewed({ source: analyticsSource });
  }, [analyticsSource]);

  const handleClick = (event) => {
    logGgPlusUpgradeClicked({ source: analyticsSource });
    if (onClick) onClick(event);
  };

  return (
    <div className={`gg_plus_card ${className}`.trim()}>
      <img src={gg_plus_logo} alt="GG+" className="gg_plus_logo" />
      <p className="gg_plus_card_headline">{headline}</p>
      <p className="gg_plus_card_body">{body}</p>
      <Link to={to} className="green_text gg_plus_card_cta" onClick={handleClick}>
        {ctaText}
      </Link>
    </div>
  );
}

export default Gg_plus_card;
